import React from 'react';
import { Box, Typography } from '@mui/material';
import ManageEmployee from './ManageEmployee';

/**
 * Employees Page - Standalone route for employee management
 * Previously a tab in the Admin component
 */
export default function EmployeesPage() {
  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        Employee Management
      </Typography>
      <ManageEmployee />
    </Box>
  );
}
